export default function eventElement(e) {
    if ( e === void 0 ) e = {};

    return e.touch ? e.touch.initialTouch : e.target;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/event-element.js
// module id = 912
// module chunks = 0